import { useQuery } from '@tanstack/react-query'

import { getTaxGroup } from '@/api/management'
import { keyStore } from '@/config/key-store'

function useTaxGroup(enabled: boolean, searchParam?: string) {
  const search = searchParam || undefined

  return useQuery({
    queryKey: [...keyStore.tax.group.queryKey, search],
    queryFn: async () => await getTaxGroup({ search }),
    refetchOnMount: false,
    staleTime: Infinity,
    enabled,
  })
}

export { useTaxGroup }
